export default __webpack_public_path__ + "static/media/cooking-facilities.2ef76894.svg";